import { TabPane } from 'reactstrap'
import AppObjectFieldTable from '../AppObjectFieldTable/AppObjectFieldTable'
import './AppObjectPane.css'

export default function AppObjectPane(props) {
  const { object, parentObjectId, action, formInputs, tab } = props
  console.log(`AppObjectPane rendered tab: ${tab.name}`, props)

  return (
    <TabPane className="app-object-tab-pane" tabId={tab.name}>
      <AppObjectFieldTable object={object} parentObjectId={parentObjectId} action={action} formInputs={formInputs} tab={tab} />
    </TabPane>
  )
}